import { Car, CarImage } from '@lib/azgaz-ui/connect';


const priority: any = {
  dealer: ['Сайт Дилера', 'Представительство'],
  hq: ['Представительство', 'Сайт Дилера']
}


const getImages = (car?: Car): Array<CarImage> => {
  const currentWidget: string = ENV.widget || 'n/a';

  const originalImages = (car?.images || []).filter(({ type }) => type === 'image');

  // Если для текущего виджета не заданы приоритеты
  if (!priority[currentWidget]) {
    return originalImages;
  }

  // Попытка отфильтровать картнки с учётом их группы
  for (let target of priority[currentWidget]) {
    const images = originalImages.filter((image: any) => (image.target || []).indexOf(target) !== -1)

    if (images.length) {
      return images;
    }
  }

  // Если по группам ничего не найдено - просто вернуть список изображений
  return originalImages;
};


export default getImages;
